import { useContext, useState, useEffect, useMemo, useId } from "react";
import {
  Badge,
  Divider,
  Dialog,
  Grid,
  Typography,
  useTheme,
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableRow,
  DialogContent,
} from "@mui/material";

import CartProduct from "./CartProduct";
import { AppContext } from "../contextProviders/AppContext";
import { centsToLocalString } from "../shared/money";

import { HiOutlineShoppingCart } from "react-icons/hi";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { motion } from "framer-motion";
import { cartIcon } from "../animation-variants";
import ButtonComponent from "./ButtonComponent";
import { translation } from "./Dictionary";
export default function Cart() {
  const {
    cart,
    selectedAdditionalServices,
    activeStep,
    handleActiveStep,
    setIsCartOpen,
    isCartOpen,
    cartTotalValue,
    deleteService,
    language,
  } = useContext(AppContext);
  const theme = useTheme();

  // Delete item from the cart at the AppContext

  const toggleCartVisibility = () => {
    setIsCartOpen((prevState) => !prevState);
  };
  // Hide delete product from the cart after confirming the reservation

  const [disableContinueButton, setDisableContinueButton] = useState(true);

  const handleAdvance = () => {
    handleActiveStep(activeStep + 1);
    setIsCartOpen();
  };

  useEffect(() => {
    if (cart.length === 0) {
      setDisableContinueButton(true);
    } else {
      setDisableContinueButton(false);
    }
  }, [cart]);

  // Total number of vehicles in cart
  const cartTotal = useMemo(() => {
    let total = 0;
    for (const c of cart) {
      total = total + c.quantity;
    }
    return total;
  }, [cart]);

  const itemKey = useId();

  return (
    <>
      <motion.div
        style={{
          // right: mobile ? "16vw" : 50,
          /*   display: "flex",
        alignItems: "center",
        justifyContent: "center", */
          cursor: "pointer",
          zIndex: 998,
          //   position: "absolute",
        }}
        initial="initial"
        animate="enter"
        exit="exit"
        variants={cartIcon}
        key={itemKey}
      >
        <div
          style={{
            position: "fixed",
            bottom: 15,
          }}
        >
          <Badge color="error" badgeContent={cartTotal} overlap="circular">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",

                backgroundColor: cart.length
                  ? theme.palette.primary.cartIconFilled
                  : theme.palette.primary.cartIconEmpty,
                height: 60,
                width: 60,
              }}
            >
              <HiOutlineShoppingCart
                style={{
                  color: "#ffffff",
                  fontSize: 32,
                }}
                onClick={() => toggleCartVisibility()}
              />
            </div>
          </Badge>
        </div>
      </motion.div>
      {isCartOpen && (
        <Dialog open maxWidth="sm" fullWidth>
          <DialogContent
            style={{ padding: 15, height: "100%", position: "relative" }}
          >
            <div style={{ position: "absolute", top: 15, right: 5 }}>
              <CloseIcon
                color={theme.palette.secondary.text}
                style={{
                  marginRight: 10,
                  fontSize: 26,
                  cursor: "pointer",
                }}
                onClick={() => toggleCartVisibility()}
              />
            </div>
            <Grid
              container
              style={{
                backgroundColor: theme.palette.primary.cartBackground,
                borderColor: theme.palette.primary.cartBorders,
                padding: 2,
                borderRadius: 4,
              }}
            >
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  style={{
                    color: theme.palette.primary.mainText,
                    letterSpacing: 1,
                  }}
                >
                  {translation.get(language, "Selected products")}
                </Typography>
              </Grid>
              <Divider />
              <Grid item xs={12}>
                {cart &&
                  cart.map((item, index) => {
                    return (
                      <CartProduct offer={item} key={`${itemKey}-${index}`} />
                    );
                  })}
              </Grid>
              {selectedAdditionalServices && (
                <Grid item xs={12}>
                  {selectedAdditionalServices.length > 0 && (
                    <Typography
                      variant="h5"
                      style={{
                        color: theme.palette.primary.mainText,
                        marginTop: 20,
                        marginBottom: 5,
                      }}
                    >
                      {translation.get(language, "Additional services")}
                    </Typography>
                  )}
                  <Divider sx={{ marginY: "15px" }} />
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        {selectedAdditionalServices.map((item) => {
                          if (item.quantity === 0) return null;

                          return (
                            <TableRow key={item.id}>
                              <TableCell
                                align="left"
                                style={{ padding: 0, width: 180 }}
                              >
                                <Typography
                                  variant="body1"
                                  style={{
                                    marginLeft: 5,
                                    color: theme.palette.primary.mainText,
                                  }}
                                >
                                  {item.description}{" "}
                                  {item.quantity > 1 && <>x {item.quantity}</>}
                                </Typography>
                              </TableCell>
                              <TableCell
                                align="right"
                                style={{ padding: 0, width: 80 }}
                              >
                                <Typography
                                  variant="body1"
                                  style={{
                                    color: theme.palette.primary.mainText,
                                  }}
                                >
                                  {centsToLocalString(
                                    //service.offerPrice
                                    item.offerPrice * item.quantity
                                  )}
                                  €
                                </Typography>
                              </TableCell>
                              <TableCell align="right" style={{ padding: 0 }}>
                                <DeleteIcon
                                  style={{
                                    color: theme.palette.secondary.text,
                                    cursor: "pointer",
                                    fontSize: 26,
                                  }}
                                  onClick={() => deleteService(item.id)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )}
              <Grid item style={{ marginTop: 20 }} xs={12}>
                {cartTotalValue > 0 ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-evenly"
                    style={{ paddingLeft: 20, paddingRight: 20 }}
                  >
                    <Typography
                      variant="h5"
                      style={{ color: theme.palette.primary.mainText }}
                    >
                      {translation.get(language, "Total text")}
                    </Typography>
                    <Typography
                      variant="h5"
                      style={{ color: theme.palette.primary.mainText }}
                    >
                      {centsToLocalString(cartTotalValue)} €
                    </Typography>
                  </Grid>
                ) : (
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    style={{ paddingLeft: 20, paddingRight: 20 }}
                  >
                    <Typography
                      variant="h5"
                      style={{ color: theme.palette.primary.mainText }}
                    >
                      {translation.get(language, "Shopping cart is empty")}
                    </Typography>
                  </Grid>
                )}
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  direction="row"
                  spacing={2}
                >
                  {activeStep === 2 && (
                    <Grid item xs={5}>
                      <ButtonComponent
                        onClick={() => toggleCartVisibility()}
                        fullWidth={true}
                        disabled={disableContinueButton}
                        variant={"contained"}
                        buttonText={translation.get(language, "Add products")}
                        fontSize={14}
                        color={"primary"}
                      />
                    </Grid>
                  )}
                  {activeStep !== 4 && (
                    <Grid item xs={5} container justifyContent="center">
                      <ButtonComponent
                        onClick={() => handleAdvance()}
                        fullWidth={true}
                        disabled={disableContinueButton}
                        variant={"contained"}
                        buttonText={translation.get(
                          language,
                          "Continue reservation"
                        )}
                        fontSize={14}
                        color={"secondary"}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
